import { createSelector } from "reselect";

import { ApplicationState } from "../../applicationState";

import { CustomerCategory } from "./model";

export const routeIdSelector = (state: ApplicationState) => {
    return state.router.params.customerCategoryId;
};

export const customerCategoriesSelector = (state: ApplicationState) => state.customerCategories.sort((a, b) => a.name.localeCompare(b.name));

export const customerCategorySelector = createSelector(
    customerCategoriesSelector,
    routeIdSelector,
    (customerCategories: CustomerCategory[], id: string) => {
        return customerCategories.find(c => c.id === id) || {} as CustomerCategory;
    }
);

export const basePathSelector = (state: ApplicationState) =>
    state.router.pathname.substring(0, state.router.pathname.indexOf("customerCategories") + "customerCategories".length);
